import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "id", "className", "submenu", "menuContainerStyles", "enableOnMouseEnterLeaveActions"];
import { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import TrackedButton from '../../TrackedButton';
import { Menu } from './Menu';
import useMenuPickerMouseTracking from '../hooks/useMenuPickerMouseTracking';
import useMenuItem from '../hooks/useMenuItem';
import withTransientStyleProps from '../../../utils/withTransientStyleProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenu = styled(withTransientStyleProps(Menu)).withConfig({
  displayName: "MenuItemWithSubmenu__StyledMenu",
  componentId: "pbr8dw-0"
})(["", ""], ({
  $menuContainerStyles
}) => $menuContainerStyles);
export const MenuItemWithSubmenu = _ref => {
  let {
      children,
      id,
      className,
      submenu,
      menuContainerStyles,
      enableOnMouseEnterLeaveActions
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const submenuRef = useRef(null);
  const {
    tabIndex,
    setRef,
    onMenuItemKeyDown,
    menuItemId,
    menuItemRef,
    activeSubmenuId,
    setActiveSubmenu
  } = useMenuItem({
    id
  });
  const {
    isSubmenuOpen,
    setIsSubmenuOpen,
    onMouseEnter,
    onMouseMove,
    onMouseLeave
  } = useMenuPickerMouseTracking({
    submenuRef,
    submenuTriggerRef: menuItemRef
  });
  const onToggleSubmenu = useCallback(nextState => {
    if (nextState !== undefined) {
      setIsSubmenuOpen(nextState);
      return;
    }
    setIsSubmenuOpen(open => !open);
  }, [setIsSubmenuOpen]);
  const onClick = useCallback(() => {
    onToggleSubmenu();
  }, [onToggleSubmenu]);
  const onSubmenuKeyDown = useCallback(evt => {
    if (evt.key === 'Right' || evt.key === 'ArrowRight') {
      onToggleSubmenu(true);
      return;
    }
    onMenuItemKeyDown(evt);
  }, [onMenuItemKeyDown, onToggleSubmenu]);
  const closeMenu = () => setIsSubmenuOpen(false);
  useEffect(() => {
    if (isSubmenuOpen) {
      setActiveSubmenu({
        id: menuItemId
      });
    }
  }, [isSubmenuOpen, menuItemId, setActiveSubmenu]);
  useEffect(() => {
    if (menuItemId && activeSubmenuId !== menuItemId) {
      setIsSubmenuOpen(false);
    }
  }, [menuItemId, activeSubmenuId, setIsSubmenuOpen]);
  return /*#__PURE__*/_jsxs("li", {
    role: "menuitem",
    className: className,
    onMouseEnter: enableOnMouseEnterLeaveActions ? onMouseEnter : undefined,
    onMouseMove: enableOnMouseEnterLeaveActions ? onMouseMove : undefined,
    onMouseLeave: enableOnMouseEnterLeaveActions ? onMouseLeave : undefined,
    children: [/*#__PURE__*/_jsx(TrackedButton, Object.assign({
      id: menuItemId,
      ref: setRef,
      onClick: onClick,
      onKeyDown: onSubmenuKeyDown,
      className: "menu-picker-button",
      "aria-haspopup": "true",
      "aria-expanded": isSubmenuOpen,
      tabIndex: tabIndex
    }, rest, {
      children: children
    })), isSubmenuOpen && activeSubmenuId === menuItemId ? /*#__PURE__*/_jsx(StyledMenu, {
      ref: submenuRef,
      $menuContainerStyles: menuContainerStyles,
      id: "menuItemSwitcher",
      "data-test-id": "nav-account-menu-picker-submenu",
      menuTriggerId: menuItemId,
      closeMenu: closeMenu,
      setFocusOnMount: true,
      shouldManageTabIndex: true,
      shouldLoopFocus: true,
      children: submenu
    }) : null]
  });
};